export default {
  form: {
    address: {
      label: 'Dirección',
      placeholder: 'Dirección',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
    city: {
      label: 'Ciudad',
      placeholder: 'Ciudad',
    },
    start_time: {
      label: 'Hora de inicio',
      placeholder: 'p. ej. 11:00',
    },
    name: {
      label: 'Nombre de la ubicación (opcional)',
      placeholder: 'p. ej. Al lado de la Fernsehturm',
      tooltip:
        'Ingresar un nombre de ubicación puede ayudar a los clientes a identificarla, p. ej. «Al lado de la Fernsehturm»',
    },
    note: {
      label: 'Nota',
      placeholder: 'Ingresar nota',
    },
  },
  buttons: {
    add_location: 'Agregar ubicación',
  },
};
